import React from "react";

export type TListingFact = {
    label: string;
    value: string;
};

export type TListingFactPanelProps = {
    heading: string;
    facts: Array<TListingFact>;
    footnote?: string;
};

export const ListingFactPanel = (props: TListingFactPanelProps): JSX.Element | null => {
    if (props.facts.length === 0) {
        return null;
    }

    return (
        <div className="listing-fact-panel">
            <div className="listing-fact-panel__heading">{props.heading}</div>
            <dl className="listing-fact-panel__list">
                {props.facts.map((fact) => (
                    <div className="listing-fact-panel__row" key={fact.label}>
                        <dt className="listing-fact-panel__label">{fact.label}</dt>
                        <dd className="listing-fact-panel__value">{fact.value}</dd>
                    </div>
                ))}
            </dl>
            {props.footnote !== undefined &&
                <div className="listing-fact-panel__footnote">{props.footnote}</div>
            }
        </div>
    );
};
